export const renameItemsWith = (label: string, newValue: string) => {
  return label.replace('items', newValue);
};
